import { useCallback } from 'react';
import * as Meter from '@givebutter/primitives/meter';
import ChangeMaker from 'images/change-maker-sticker.png';
import GBLogo from 'images/logo-sticker.svg';
import Party from 'images/party.png';

interface OnboardingJumboProps {
    title: string;
    body: string;
    showParty: boolean;
    showGoalBar: boolean;
    percentComplete: number;
}

const OnboardingJumbo = (props: OnboardingJumboProps) => {
    const { title, body, showParty, showGoalBar, percentComplete } = props;
    const Logo = useCallback(
        () =>
            showGoalBar ? (
                <div className="relative hidden md:block">
                    <img
                        src={GBLogo}
                        alt={'Givebutter logo sticker'}
                        className="absolute right-0 top-0 w-10"
                    />
                    <img src={ChangeMaker} alt={'Change maker sticker'} className={`w-36`} />
                </div>
            ) : (
                <div className="text-right">
                    <Meter.Root
                        value={percentComplete}
                        aria-label="Percent completed"
                        type="circle"
                        variant="success"
                        size="md"
                    >
                        <Meter.CircularContainer>
                            <Meter.CircularTrack />
                            <Meter.CircularIndicator />
                        </Meter.CircularContainer>
                    </Meter.Root>
                </div>
            ),
        [showGoalBar, percentComplete],
    );

    return (
        <div className={`grid grid-cols-4 p-6 ${showGoalBar ? 'pb-4' : ''}`}>
            <div className="col-span-3 flex flex-col justify-evenly gap-1">
                <div className={'text-2xl font-medium'}>{title}</div>
                <div className={'text-xl text-gray-600'}>{body}</div>
            </div>
            {showParty ? (
                <div className="relative hidden md:block">
                    <img src={Party} alt={'Confetti'} className="float-right w-20" />
                </div>
            ) : (
                <Logo />
            )}
        </div>
    );
};

export { OnboardingJumbo };
export type { OnboardingJumboProps };
